import {API_URL, apiGet} from '../api'
import {ApiRes} from '../../types/api'

export interface IBanners {
    id: string
    language: string
    is_active: boolean
    priority: number
    created_at: string
    updated_at: string
    banner_image_pc?: string
    banner_image_mo?: string
    background?: string
    url?: string
    sub_title: {
        type?: string
        image_url?: string
        text?: string
        color?: string
    }
    placement?: string[]
    content: {
        image_pc?: string
        image_mo?: string
        title?: string
        desc?: string
        title_color?: string
        desc_color?: string
    }
    button: {
        text?: string
        link?: string
        view?: string
        text_color?: string
        border_color?: string
        background_color?: string
        hover_background_color?: string
    }
    pop_up_image?: string
}

export const getLeaderboardBanner = async (
    size: number = 10,
    current_page: number = 1,
): Promise<ApiRes<IBanners[]>> => {
    return await apiGet(API_URL, `admin/banners?page_size=${size}&current_page=${current_page}`)
}
